module.exports = __webpack_public_path__ + "static/media/finger_update_blue.d3240c53.svg";